import images from "./images";

const projects = [
    {
        id: 1,
        image: images.project1,
        title: "Luxury Residence",
        details: {
            date: "March 18, 2024",
            client: "Urban Loft Interiors",
            category: "Interiors",
            duration: "6 Weeks",
            location: "Downtown Seattle, WA",
            cost: "Custom quotation based on scope and material finishes",
            leadDesigner: "Samantha Woodrow"
        },
        paragraphs: [
            "Designed to elevate a contemporary urban lifestyle, the Luxury Residence Interiors project focused on creating a seamless blend of sophistication and comfort. Each room was thoughtfully curated to embody the client’s refined taste and the architectural character of the space.",
            "From tailored lighting schemes to bespoke material palettes, our team ensured every element—from furnishings to finishes—enhanced spatial harmony. The design featured marble accents, warm wood textures, and custom cabinetry with integrated technology."
        ],
        gallery: [
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6,
        ],
        challenges: [
            "Coordinating Multiple High-End Material Vendors",
            "Maintaining Cohesion Across Varied Interior Spaces",
            "Ensuring Precision During On-Site Custom Installations"
        ],
        solutions: [
            "Early Procurement and Vendor Collaboration",
            "Comprehensive Interior Mood Boards and Finish Samples",
            "On-Site Supervision with Precision CAD-Based Implementation"
        ],
        results: [
            "Transformed the Residence into a Timeless Interior Showcase",
            "Exceeded Client Expectations for Elegance and Usability",
            "Strengthened Portfolio in the Premium Urban Residential Market"
        ]
    },
    {
        id: 2,
        image: images.project2,
        title: "Estate Landscaping",
        details: {
            date: "March 18, 2024",
            client: "Urban Loft Interiors",
            category: "Landscape",
            duration: "6 Weeks",
            location: "Downtown Seattle, WA",
            cost: "Custom estimate based on terrain, plant selection, and scope",
            leadDesigner: "Samantha Woodrow"
        },
        paragraphs: [
            "The Estate Landscaping project transformed an urban property into a serene, multi-functional outdoor environment. Our team designed a landscape that balances natural beauty with refined structure, creating an outdoor extension of the client’s lifestyle.",
            "With curated plant selections, reclaimed stone pathways, and custom-built garden features, we prioritized sustainable practices, seasonal interest, and long-term maintenance efficiency. Every element was planned to harmonize with the surrounding architecture and climate."
        ],
        gallery: [
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6,
        ],
        challenges: [
            "Navigating Grading Issues on Sloped Terrain",
            "Sourcing Mature Plant Specimens for Immediate Impact",
            "Ensuring Drainage Without Disrupting Design Flow"
        ],
        solutions: [
            "Implementing Tiered Garden Design and Retaining Structures",
            "Partnering with Regional Nurseries for Select Flora",
            "Integrating Subsurface Drainage and Permeable Surfaces"
        ],
        results: [
            "Delivered a Tranquil, Cohesive Estate Landscape On Time",
            "Increased Property Value and Usable Outdoor Space",
            "Received Positive Client Feedback and Local Recognition"
        ]
    },
    {
        id: 3,
        image: images.project3,
        title: "Kitchen Renovation",
        details: {
            date: "March 18, 2024",
            client: "Urban Loft Interiors",
            category: "Renovations",
            duration: "6 Weeks",
            location: "Downtown Seattle, WA",
            cost: "Customized based on layout changes and finish selections",
            leadDesigner: "Samantha Woodrow"
        },
        paragraphs: [
            "This Kitchen Renovation project redefined the heart of a modern loft apartment, blending function and sophistication. The goal was to create a culinary space that supported daily living while elevating the aesthetic appeal of the home.",
            "Our team managed every phase—from demolition and spatial reconfiguration to installing high-performance appliances and elegant finishes. The final result features quartz countertops, custom cabinetry, smart storage solutions, and ambient lighting for a warm, inviting atmosphere."
        ],
        gallery: [
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6,
        ],
        challenges: [
            "Working Within Existing Plumbing and Electrical Constraints",
            "Maximizing Storage Without Sacrificing Openness",
            "Sourcing High-End Materials Within Budget"
        ],
        solutions: [
            "Careful Coordination with Mechanical Contractors During Planning",
            "Custom Cabinetry and Multi-Functional Island Design",
            "Value Engineering with Premium-Look Alternatives"
        ],
        results: [
            "Delivered a Stylish, Functional Kitchen Ahead of Schedule",
            "Enhanced the Home’s Value and Daily Living Experience",
            "Showcased in Client's Portfolio for Modern Urban Living"
        ]
    },
    {
        id: 4,
        image: images.project4,
        title: "Office Workspace",
        details: {
            date: "March 18, 2024",
            client: "Urban Loft Interiors",
            category: "Interiors",
            duration: "6 Weeks",
            location: "Downtown Seattle, WA",
            cost: "Tailored estimate based on scale, furnishings, and tech integration",
            leadDesigner: "Samantha Woodrow"
        },
        paragraphs: [
            "The Office Workspace project focused on creating a dynamic, efficient environment tailored to modern professionals. Designed for a creative agency, the space needed to foster collaboration, concentration, and a sense of identity.",
            "We developed an open-plan layout with zoning for private offices, collaborative areas, and break spaces. Materials like acoustic panels, warm wood tones, and integrated lighting helped balance utility with visual comfort. Custom desks, modular storage, and branded interior elements completed the transformation."
        ],
        gallery: [
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6,
        ],
        challenges: [
            "Balancing Open Layouts with Acoustic Privacy",
            "Integrating Smart Tech Without Visual Clutter",
            "Maximizing Utility in a Compact Footprint"
        ],
        solutions: [
            "Use of Sound-Absorbing Materials and Flexible Partitions",
            "Concealed Cabling and Built-in Device Hubs",
            "Modular Furniture Systems and Multi-Use Zones"
        ],
        results: [
            "Delivered a Cohesive, Branded Workspace Aligned with Company Culture",
            "Improved Team Productivity and Client Impressions",
            "Set a New Standard for Flexible Urban Office Design"
        ]
    },
    {
        id: 5,
        image: images.project5,
        title: "Residential Garden",
        details: {
            date: "March 18, 2024",
            client: "Urban Loft Interiors",
            category: "Landscape",
            duration: "6 Weeks",
            location: "Downtown Seattle, WA",
            cost: "Custom pricing based on planting design, materials, and site prep",
            leadDesigner: "Samantha Woodrow"
        },
        paragraphs: [
            "The Residential Garden project was designed to transform a compact urban backyard into a peaceful, functional retreat. Our goal was to enhance outdoor living while maintaining harmony with the client’s architectural style and personal preferences.",
            "Through layered planting, native flora, and strategic hardscaping, we introduced texture, color, and structure. Features included a small dining patio, raised herb beds, a water feature, and ambient garden lighting to create a year-round haven."
        ],
        gallery: [
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6,
        ],
        challenges: [
            "Optimizing a Limited Outdoor Footprint",
            "Designing for Seasonal Variety and Low Maintenance",
            "Ensuring Privacy Without Blocking Natural Light"
        ],
        solutions: [
            "Multi-Zoned Layout with Vertical Garden Elements",
            "Use of Hardy Perennials and Automated Irrigation",
            "Custom Trellises and Selective Planting for Privacy Screening"
        ],
        results: [
            "Delivered a Lush, Low-Maintenance Garden Perfect for Urban Living",
            "Created a Private Outdoor Escape that Complements the Home",
            "Increased Usable Outdoor Space and Year-Round Enjoyment"
        ]
    },
    {
        id: 6,
        image: images.project6,
        title: "Bathroom Remodel",
        details: {
            date: "March 18, 2024",
            client: "Urban Loft Interiors",
            category: "Renovations",
            duration: "6 Weeks",
            location: "Downtown Seattle, WA",
            cost: "Based on layout changes, fixture selections, and material finishes",
            leadDesigner: "Samantha Woodrow"
        },
        paragraphs: [
            "This Bathroom Remodel project focused on transforming a dated, compact space into a luxurious and highly functional sanctuary. The design embraced a minimalist yet warm aesthetic to elevate the everyday experience.",
            "Our scope included layout reconfiguration, custom vanity design, and the installation of premium finishes. The space now features a walk-in glass shower, large-format porcelain tiles, matte black fixtures, and integrated lighting for a spa-like atmosphere."
        ],
        gallery: [
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6,
        ],
        challenges: [
            "Working Within Tight Spatial Constraints",
            "Upgrading Outdated Plumbing and Electrical Systems",
            "Maximizing Storage Without Cluttering the Design"
        ],
        solutions: [
            "Efficient Layout Planning and Space-Saving Fixtures",
            "Close Coordination with MEP Specialists During Demolition",
            "Built-In Shelving, Niche Storage, and Floating Vanity Installation"
        ],
        results: [
            "Delivered a Contemporary, High-Function Bathroom on Schedule",
            "Improved Daily Usability and Long-Term Property Value",
            "Highlighted in Client Showcase for Modern Urban Bathrooms"
        ]
    }

];

export default projects;